import React, { useState, useEffect } from "react";

const ConnectTab = ({ updateChatTabData, chatTabData }) => {
    const [telegramUsername, setTelegramUsername] = useState("");

    useEffect(() => {
        if (chatTabData?.telegram_username) {
            setTelegramUsername(chatTabData.telegram_username);
        }
    }, [chatTabData?.telegram_username]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setTelegramUsername(value);
        updateChatTabData("telegram_username", value);
    };

    return (
        <div className="whats-app-side-baar-connect-tab">
            <span>Connect</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        value={telegramUsername}
                        onChange={handleInputChange}
                        placeholder="Telegram Username or link"
                    />
                </div>
            </div>
            <p>Example: durov </p>
        </div>
    );
};

export default ConnectTab;